import Drawer from 'components/Drawer'
import React from 'react'
import AddConfirm from './Partials'

const ConfirmDrawer = ({
  confirmDrawer,
  setConfirmDrawer,
  file,
  rolesMetrics,
  setSearchParams,
  searchParams,
}) => {
  function isObject(value) {
    return typeof value === 'object' && value !== null
  }
  const onClose = () => {
    setSearchParams({
      ...searchParams,
      stage: rolesMetrics?.roundName,
      type: rolesMetrics?.type ? rolesMetrics?.type : 'all',
      assessment: rolesMetrics?.assesmentType
        ? rolesMetrics?.assesmentType
        : 'Test Gorilla',
      isUpload: isObject(rolesMetrics?.extAssmnts),
      assessmentId: rolesMetrics?.extAssmnts?.id,
      isBack: false,
    })
    setConfirmDrawer(false)
  }

  const content = () => {
    return (
      <AddConfirm
        confirmDrawer={confirmDrawer}
        setConfirmDrawer={setConfirmDrawer}
        onClose={onClose}
        file={file}
      />
    )
  }

  return (
    <Drawer
      width="40%"
      title={'Bulk Upload'}
      placement="right"
      padding="30px"
      headerpadding="16px 30px"
      closable
      onClose={onClose}
      visible={confirmDrawer}
      content={content()}
    />
  )
}

export default ConfirmDrawer
